import styled from 'styled-components';

import { PALETTE_COLORS, SEMANTIC_COLORS } from '@/constant/unit/color';
import { DEVICE } from '@/constant/unit/device';

export const S = {
  Layout: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: center;
    flex: 1;

    width: 100%;
    max-width: 400px;
    padding: 50px 40px;
  `,
  LayoutLogoBanner: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: fit-content;

    & > img {
      width: 100%;
      max-width: 300px;
    }
  `,
  BannerTitle: styled.div`
    align-self: flex-end;
    margin-top: 5px;
    color: ${PALETTE_COLORS.PRIMARY_500};
    font-size: 18px;

    @media ${DEVICE.mobileM} {
      font-size: 20px;
    }
  `,
  LayoutSection: styled.div`
    display: flex;
    flex-direction: column;

    width: 100%;
    padding: 25px;
    margin-top: 50px;

    border-radius: 20px;
    border: 1px dashed ${SEMANTIC_COLORS.PRIMARY_BORDER};
  `,
  SectionTitle: styled.strong`
    margin-bottom: 5px;
    color: ${SEMANTIC_COLORS.DEFAULT_TITLE};
  `,
  SectionText: styled.div`
    color: ${SEMANTIC_COLORS.SECONDARY_TEXT};
  `,
  LayoutActionButton: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 100%;
  `,
  LineButton: styled.button`
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 56px;

    border-radius: 10px;
    background: #00b900;

    cursor: pointer;
  `,
  LineButtonText: styled.div`
    color: ${PALETTE_COLORS.NEUTRAL_100};
    font-size: 24px;
    font-weight: 700;
  `,
  LineImg: styled.img`
    width: 50px;
  `,
  InstructionImg: styled.img`
    width: 100%;
    margin-top: 15px;
  `,
  LinkButton: styled.a`
    width: fix-content;
    margin-top: 15px;

    color: ${PALETTE_COLORS.NEUTRAL_800};
    text-decoration-line: underline;
    text-align: center;
    line-height: 20px;

    cursor: pointer;
  `,
  Gap: styled.div<{ height: number }>`
    width: 100%;
    height: ${(props) => props.height}px;
  `,
};
